/**
 * Transforms camelCase strings to kebab-case
 *
 * @example
 * // returns "camel-case-string"
 * camelCaseToKebabCase("camelCaseString");
 * @param camelCaseString
 * @returns string
 */
export const camelCaseToKebabCase = (camelCaseString: string) =>
  camelCaseString.replace(
    /[A-Z]+(?![a-z])|[A-Z]|\d+/g,
    (match, offset) => `${offset ? '-' : ''}${match.toLowerCase()}`
  );
